import React from 'react';
import PageSyle from '../style';
import NextBackNav from '../../../components/nextBackNav';
import RoundScreen from '../../../components/roundScreen';

export default function Page10({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = PageSyle();
	return (
		<div style={style.outerStyle()}>
			<RoundScreen
				title='Run 3 - 4 Rounds'
				isNumberd={true}
				rounds={[
					[
						{header: 'Type', value: 'ALPHA'},
						{header: 'C.C.M.R’s', value: 'STANDARD BENCH PRESS (BB)'},
						{header: 'REPS Sec / Min', value: '6 - 8'},
						{header: 'WEIGHT LEVEL', value: 'Heavy'},
					],
					[
						{header: 'Type', value: 'BETA'},
						{header: 'C.C.M.R’s', value: 'BANDED PUSH-UPS'},
						{header: 'REPS Sec / Min', value: '10'},
						{header: 'WEIGHT LEVEL', value: 'Light --> Mild'},
					],
					[
						{header: 'Type', value: 'BETA'},
						{header: 'C.C.M.R’s', value: 'DIPS'},
						{header: 'REPS Sec / Min', value: '10'},
						{header: 'WEIGHT LEVEL', value: 'Body Weight'},
					],
					[
						{header: 'Type', value: 'BETA'},
						{header: 'C.C.M.R’s', value: 'SUICIDES'},
						{header: 'REPS Sec / Min', value: '1min'},
						{header: 'WEIGHT LEVEL', value: 'Cardio / Explosive'},
					],
				]}
			/>
			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
